import React, { useContext, useMemo } from 'react'
import styles from '../styles.module.scss'
import { WebLessonsContext } from '../../../utils/context';

import { MdScreenShare, MdStopScreenShare } from "react-icons/md";
import { FaPowerOff } from "react-icons/fa";
import { BsCameraVideoFill, BsCameraVideoOffFill } from "react-icons/bs";


const NavPanel = ({ data }) => {

  const { leaveRoom, toggleScreenShare, participants, toggleVideo } = useContext(WebLessonsContext)

  const teacherPart = useMemo(() => participants.find(p => p._attributes.position === 'teacher'), [participants])

  const [videoTrack, shareTrack] = Array.from(teacherPart?.videoTrackPublications.values() || [])

  const ShareIcon = shareTrack ? MdStopScreenShare : MdScreenShare
  const VideoIcon = videoTrack?.isMuted ? BsCameraVideoOffFill : BsCameraVideoFill

  return (
    <div className={styles.navPanel}>
      <div>
        <VideoIcon onClick={toggleVideo} color={videoTrack?.isMuted ? 'red' : 'white'} />
        <ShareIcon onClick={toggleScreenShare} color={shareTrack ? 'red' : 'white'} />
      </div>

      <div>
        <p>{data.stream}</p>
        <p>{data.description}</p>
      </div>

      <FaPowerOff onClick={leaveRoom} />

    </div>

  )
}

export default NavPanel